import Cookies from 'js-cookie';

const ACCESS_TOKEN_NAME = 'accessToken';
const COOKIE_PROMPT_ACCEPTED_NAME = 'cookie_prompt_accepted';

export function storeAccessToken(token: string) {
	console.debug('storing cookie');
	Cookies.set(ACCESS_TOKEN_NAME, token, { expires: 1, secure: true });
}

export function removeAccessToken() {
	Cookies.remove(ACCESS_TOKEN_NAME);
}

export function getAccessToken(): string | null {
	return Cookies.get(ACCESS_TOKEN_NAME) ?? null;
}

export function getCookiePromptAccepted(): boolean | null {
	const cookie = Cookies.get(COOKIE_PROMPT_ACCEPTED_NAME);
	if (cookie === undefined) return null; // User hasn't made a choice yet
	return cookie === 'true';
}

export function setCookiePromptAccepted(accepted: boolean) {
	Cookies.set(COOKIE_PROMPT_ACCEPTED_NAME, accepted.toString(), { expires: 365 });
}